import classname from 'classnames';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const Modal = ({ children, visible, addClass }) => {

    const modalClass = classname(
        addClass,
        {
            modal: true
        }
    );

    return visible ?
        ReactDOM.createPortal(
            <div className={modalClass}>
                <div className='modal__content'>
                    {children}
                </div>
            </div>
            , document.body
        )
        : null;
}

Modal.propTypes = {
    visible: PropTypes.bool,
    addClass: PropTypes.string,
    children: PropTypes.node
}

export default Modal;
